import { ConfigColor } from "../shared/config-color";

export class ColorGenerator {

    public generarColorHexAleatorio(): ConfigColor {
        let color: ConfigColor = new ConfigColor();
        let a = Math.floor(Math.random() * 256);
        let b = Math.floor(Math.random() * 256);
        let c = Math.floor(Math.random() * 256);

        let idConcatenado: string = a.toString() + b.toString() + c.toString();

        color.id = Number(idConcatenado);
        color.hex = "#" + this.generarHex(a) + this.generarHex(b) + this.generarHex(c);
        color.nombre = "";

        return color;
    }

    public generarHex(c: number): string {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }

    public generarColorHex(a: number, b: number, c: number): ConfigColor {
        let color: ConfigColor = new ConfigColor();

        let idConcatenado: string = a.toString() + b.toString() + c.toString();

        color.id = Number(idConcatenado);
        color.hex = "#" + this.generarHex(a) + this.generarHex(b) + this.generarHex(c);
        color.nombre = "";

        return color;
    }
}